<template>
  <div class="calendar-body" :key="calendarKey">
    <loader :isShow="isLoading" :textInfo="''" />
    <div class="calendar-wrapper">
      <div class="calendar-content" id="calendarContent">
        <calendar-view
          :show-date="showDate"
          :items="calendarData"
          :itemContentHeight="'3em'"
          @click-item="onClickItem"
        >
          <div class="header-wrapper" slot="header">
            <div class="left">
              <button @click="changeMonth('prev')" class="arrow-btn">
                <span>
                  <img
                    style="margin-top: 4px"
                    alt="leftArrow"
                    src="../../../assets/arrowLeft.svg"
                  />
                </span>
              </button>
              <button @click="changeMonth('next')" class="arrow-btn">
                <span>
                  <img
                    style="margin-top: 4px"
                    alt="rightArrow"
                    src="../../../assets/arrowRight.svg"
                  />
                </span>
              </button>
              <span class="current-date">{{ currentDate }}</span>
            </div>
            <div class="right">
              <v-popover offset="16" :auto-hide="true" placement="bottom-start">
                <button class="select-btn">
                  <span>Properties</span>
                  <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
                </button>

                <template slot="popover">
                  <GenericSearchCheckBoxMenu
                    @property-checked="filterProperties"
                    :checked="filteredProperties"
                    displayProperty="internalName"
                    :things="properties"
                    searchThing="property"
                    :key="'calendar-property-filter'"
                  />
                </template>
              </v-popover>

              <v-popover offset="16" :auto-hide="true" placement="bottom-end">
                <button class="select-btn">
                  <span>Chores</span>
                  <img class="down-arrow" src="@/assets/DownGreyArrow.svg" />
                </button>

                <template slot="popover">
                  <GenericSearchCheckBoxMenu
                    @chore-checked="filterChores"
                    :checked="filteredChores"
                    displayProperty="name"
                    :things="propChores"
                    searchThing="chore"
                    :key="'calendar-chore-filter'"
                  />
                </template>
              </v-popover>

              <v-popover v-if="showExpandedView" :auto-hide="true">
                <expanded-view
                  :coords="currentCoords"
                  :tasks="currentTasks"
                  @close="showHideExpandedView"
                  @edit="showDetailFromExpanded"
                />
              </v-popover>

              <button @click="showChoreModal" class="new-chore">
                New Chore
              </button>
            </div>
          </div>

          <template slot="dayContent" slot-scope="{ day }">
            <div class="day-scroll-container">
              <div
                v-for="task in getCalendarTasksForDay(day)"
                :key="task.id"
                class="day-task-item"
                @click.stop="onClickDayTask($event, task)"
              >
                {{ task.title }}
              </div>
            </div>
          </template>
        </calendar-view>

        <div class="task-info" :style="detailStyle" v-if="showDetail">
          <ChoreCalendarDetail
            @edit="showEdit"
            @close="hideDetail"
            @delete-assignment="deleteAssignment"
            :details="choreDetails"
          />
        </div>
      </div>
    </div>
    <div v-if="showEditModal">
      <ChoreAssignModal
        :current="choreDetails"
        @saved="onSaved"
        @close="hideEdit"
        @loading="isLoading = $event"
      />
    </div>
    <div v-if="showChoreMenu">
      <NewChoreMenu
        @save-create="choreCreated"
        @cancel="hideChoreModal"
        @loading="isLoading = $event"
      />
    </div>
  </div>
</template>

<script>
import { CalendarView } from 'vue-simple-calendar'
import ChoreCalendarDetail from '../ChoreCalendarDetail.vue'
import ChoreAssignModal from './ChoreAssignModal.vue'
import moment from 'moment'
import calls from '@/api/calls'
import GenericSearchCheckBoxMenu from '@/components/GenericSearchCheckBoxMenu'
import NewChoreMenu from '@/components/tasks/NewChoreMenu.vue'
import ExpandedView from './ExpandedView.vue'
import Loader from '@/components/Loader.vue'

export default {
  data: function () {
    return {
      showDate: new Date(),
      taskData: [],
      chores: [],
      filteredChores: [],
      propChores: [],
      properties: [],
      filteredProperties: [],
      showDetail: false,
      topPos: 0,
      leftPos: 0,
      choreDetails: null,
      showEditModal: false,
      showChoreMenu: false,
      calendarKey: 0,
      currentTasks: null,
      showExpandedView: false,
      currentCoords: { x: 0, y: 0 },
      isLoading: false
    }
  },
  components: {
    CalendarView,
    ChoreCalendarDetail,
    ChoreAssignModal,
    GenericSearchCheckBoxMenu,
    NewChoreMenu,
    ExpandedView,
    Loader
  },
  methods: {
    async deleteAssignment(assignment) {
      const { message, data } = await calls.DELETE(
        `assignment/${assignment.assignmentId}`
      )
      this.hideDetail()
      this.getCalendarData()
    },
    getValue(day) {
      const dayIso = moment(day).format('YYYY-MM-DD') + 'T00:00:00.000Z'
      let value = 0
      for (const datum of this.taskData) {
        if (datum.startDate == dayIso) {
          value += 1
        }
      }
      return value
    },
    getTasks(day) {
      const dayIso = moment(day).format('YYYY-MM-DD') + 'T00:00:00.000Z'

      const tasks = []
      for (const datum of this.taskData) {
        if (datum.startDate == dayIso) {
          tasks.push(datum)
        }
      }
      return tasks
    },
    onClickItem(e, v) {
      let parentRect = v.srcElement.getBoundingClientRect()
      let relativeRect = document
        .getElementById('calendarContent')
        .getBoundingClientRect()
      if (parentRect.x > 1100) {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left - 100
      } else {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left
      }
      this.choreDetails = {
        housemateId: e.originalItem.housemateId,
        propertyId: e.originalItem.propertyId,
        choreId: e.originalItem.choreId,
        assignmentId: e.originalItem.assignmentId,
        originalDate: e.originalItem.originalDate,
        selectedDate: moment.utc(e.originalItem.startDate).format('YYYY-MM-DD'),
        title: e.originalItem.taskName,
        user: e.originalItem.title,
        date: moment.utc(e.originalItem.startDate).format('ddd MMM DD YYYY'), //e.originalItem.startDate,
        property: e.originalItem.propertyName
      }
      this.showDetail = true
    },
    showChoreModal() {
      this.showChoreMenu = true
    },
    hideChoreModal() {
      this.showChoreMenu = false
      this.isLoading = false
    },
    hideDetail() {
      this.showDetail = false
    },
    showDetailFromExpanded(obj) {
      const { task, event } = obj
      let parentRect = event.srcElement.getBoundingClientRect()
      let relativeRect = document
        .getElementById('calendarContent')
        .getBoundingClientRect()
      if (parentRect.x > 1100) {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left - 100
      } else {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left
      }
      this.choreDetails = {
        housemateId: task.housemateId,
        propertyId: task.propertyId,
        choreId: task.choreId,
        selectedDate: moment(task.startDate).format('YYYY-MM-DD'),
        title: task.taskName,
        user: task.title,
        date: moment(task.startDate).format('ddd, MMMM DD'),
        property: task.propertyName
      }
      this.showDetail = true
    },
    showEdit() {
      this.hideDetail()
      this.showEditModal = true
    },
    hideEdit() {
      this.showEditModal = false
      this.isLoading = false
    },
    showHideExpandedView(e, day) {
      this.showExpandedView = !this.showExpandedView
      if (!this.showExpandedView) return
      this.currentTasks = this.getTasks(day)
      let x, y
      let parentRect = e.srcElement.getBoundingClientRect()
      let relativeRect = document
        .getElementById('calendarContent')
        .getBoundingClientRect()

      x =
        parentRect.x > 1100
          ? parentRect.left - relativeRect.left - 100
          : parentRect.x < 400
          ? parentRect.left - relativeRect.left + 100
          : parentRect.left - relativeRect.left

      y =
        parentRect.y > 300
          ? parentRect.top - relativeRect.top - 100
          : parentRect.top - relativeRect.top + 100

      this.currentCoords = { x, y }
    },
    getCalendarTasksForDay(day) {
      const dayIso = moment(day).format('YYYY-MM-DD') + 'T00:00:00.000Z'
      return this.calendarData.filter((d) => d.startDate === dayIso)
    },
    onClickDayTask(event, task) {
      let parentRect = event.currentTarget.getBoundingClientRect()
      let relativeRect = document
        .getElementById('calendarContent')
        .getBoundingClientRect()
      if (parentRect.x > 1100) {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left - 100
      } else {
        this.topPos = parentRect.top - relativeRect.top
        this.leftPos = parentRect.left - relativeRect.left
      }
      this.choreDetails = {
        housemateId: task.housemateId,
        propertyId: task.propertyId,
        choreId: task.choreId,
        assignmentId: task.assignmentId,
        originalDate: task.originalDate,
        selectedDate: moment.utc(task.startDate).format('YYYY-MM-DD'),
        title: task.taskName,
        user: task.title,
        date: moment.utc(task.startDate).format('ddd MMM DD YYYY'),
        property: task.propertyName
      }
      this.showDetail = true
    },
    choreCreated() {
      this.getCalendarData()
      this.getProperties()
      this.getChores()
      this.showChoreMenu = false
    },
    changeMonth(input) {
      this.hideDetail()
      if (input === 'prev') {
        this.showDate = moment(this.showDate).add(-1, 'month').toDate()
      } else if (input === 'next') {
        this.showDate = moment(this.showDate).add(1, 'month').toDate()
      }
    },
    onSaved() {
      this.hideEdit()
      this.getCalendarData()
    },
    async getCalendarData() {
      let { error, data } = await calls.GET('assignment/in/full')
      if (!error) {
        this.taskData = []
        for (let datum of data) {
          const housemate = datum[0]
          const assignment = datum[1]
          const chore = datum[2]
          const property = datum[3]
          const id = `${housemate.uuid}_${assignment.date}_${chore.uuid}_${property.uuid}`
          let existTaskIndex = this.taskData.findIndex((a) => a.id === id)
          const startDate = moment.utc(assignment.date)
          startDate.set({ hour: 0, minute: 0, second: 0, milliseconds: 0 })
          if (existTaskIndex === -1) {
            this.taskData.push({
              id: id,
              housemateId: housemate.uuid,
              choreId: chore.uuid,
              propertyId: property.uuid,
              assignmentId: assignment.uuid,
              originalDate: assignment.originalDate,
              startDate: startDate.toISOString(),
              classes: 'task-date',
              title: housemate.name,
              taskName: chore.name,
              propertyName: `${property.name} - ${property.state}`
            })
          }
        }
      }
    },
    async getProperties() {
      const { data, message } = await calls.GET('properties')
      this.properties = data
    },
    async getChores() {
      const { data, message } = await calls.GET('chores')
      this.chores = data
      this.propChores = data
    },
    filterChores(id) {
      if (this.filteredChores.includes(id)) {
        const index = this.filteredChores.indexOf(id)
        this.filteredChores.splice(index, 1)
      } else {
        this.filteredChores.push(id)
      }
    },
    filterProperties(id) {
      if (this.filteredProperties.includes(id)) {
        const index = this.filteredProperties.indexOf(id)
        this.filteredProperties.splice(index, 1)
      } else {
        this.filteredProperties.push(id)
      }

      // Filter chores based on selected properties
      let filtChor = []
      for (let i = 0; i < this.chores.length; i++) {
        if (this.filteredProperties.includes(this.chores[i].propertyId))
          filtChor.push(this.chores[i])
      }

      if (this.filteredProperties.length == 0) this.propChores = this.chores
      else this.propChores = filtChor

      // Leave selected chores if they match property
      let ids = []
      for (let i = 0; i < this.propChores.length; i++)
        ids.push(this.propChores[i].uuid)

      for (let i = this.filteredChores.length; i >= 0; i--) {
        let id = this.filteredChores[i]
        if (!ids.includes(id)) {
          this.filteredChores.splice(i, 1)
        }
      }
    }
  },
  computed: {
    currentDate() {
      return moment(this.showDate).format('MMMM YYYY')
    },
    detailStyle() {
      return `top:${this.topPos}px;left:${this.leftPos}px;`
    },
    calendarData() {
      let tasks = [...this.taskData]
      if (this.filteredChores.length > 0) {
        tasks = tasks.filter((e) => this.filteredChores.includes(e.choreId))
      }
      if (this.filteredProperties.length > 0) {
        tasks = tasks.filter((e) =>
          this.filteredProperties.includes(e.propertyId)
        )
      }
      return tasks
    }
  },
  mounted() {
    this.getCalendarData()
    this.getProperties()
    this.getChores()
  }
}
</script>
<style>
.calendar-body {
  padding: 24px;
  background-color: #f5f6f8;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box !important;
}
.calendar-body .task-info {
  position: absolute;
}
.calendar-body .task-info .chore-calendar-detail-container {
  position: relative !important;
  height: auto;
  width: 192px;
}
.calendar-body
  .task-info
  .chore-calendar-detail-container
  .chore-calendar-detail-title {
  font-family: 'Montserrat';
  font-size: 10px;
}
.chore-calendar-detail-title {
  font-size: 13px !important;
}

.calendar-body
  .task-info
  .chore-calendar-detail-container
  .chore-calendar-detail-top-container {
  padding-left: 70%;
}

.calendar-body
  .task-info
  .chore-calendar-detail-container
  .chore-calendar-detail-el {
  font-family: 'Montserrat';
  font-size: 10px;
}

.chore-calendar-detail-el {
  font-size: 12px !important;
}

.calendar-body .calendar-wrapper {
  background: #ffffff;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.calendar-body .calendar-wrapper .calendar-content {
  margin: 0 20px;
  padding-bottom: 30px;
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.calendar-content .cv-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.calendar-content .cv-weeks {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.calendar-body .calendar-wrapper .calendar-content .header-wrapper {
  position: relative;
  display: block;
  height: 50px;
  margin-top: 30px;
}

.calendar-content .cv-week {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.calendar-content .cv-item.task-date {
  border: 0.5px solid var(--rentalios-dark);
  border-radius: 4px;
  font-size: 10px;
  color: var(--rentalios-dark);
  padding: 5px;
  margin: 10px 5px 5px 5px;
  width: calc(100% / 7 - 10px) !important;
  text-align: left;
  width: calc(12% - 0.04em);
  cursor: pointer;
  background: white;
}

.calendar-content .cv-item.task-date::after {
  position: absolute;
  content: '...';
  transform: rotate(90deg);
  font-size: 20px;
  display: inline-block;
  right: 0;
}

.header-wrapper .left {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
}

.header-wrapper .right {
  position: absolute;
  bottom: 15px;
  right: 0;
  display: flex;
}

.header-wrapper .right .down-arrow {
  position: absolute;
  right: 10px;
  top: 18px;
}

.header-wrapper .right .select-btn {
  position: relative;
  width: 120px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #cbd4dc;
  border-radius: 4px;
  color: #767675;
  font-size: 14px;
  margin-left: 16px;
  text-align: left;
  cursor: pointer;
  padding-left: 16px;
}

.header-wrapper .right .new-chore {
  background: #66b015;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  width: 160px;
  border: 1px solid #66b015;
  height: 40px;
  margin-left: 16px;
  cursor: pointer;
}

.header-wrapper .arrow-btn {
  background: #ffffff;
  border: 1px solid #dfdfdf;
  width: 32px;
  height: 32px;
  color: #dfdfdf;
  cursor: pointer;
}

.header-wrapper .current-date {
  padding-left: 16px;
  padding-top: 9px;
  color: #000000;
  font-weight: 800;
  font-size: 24px;
  display: block;
}

.calendar-body .new-chore-background {
  z-index: 2 !important;
}

.calendar-body .header-wrapper .v-popover.open .select-btn {
  border: 1px solid #66b015;
  color: #66b015;
}

.calendar-body .header-wrapper .v-popover.open .select-btn img {
  transform: rotate(180deg);
}

.task-calendar-day-detail-container {
  height: 20px;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
}

.task-calendar-day-detail {
  width: 20px;
  height: 20px;
  background: #f0f8e8;
  border-radius: 2px;
  border: none;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 10px;
  line-height: 20px;
  color: #66b015;
  position: absolute;
}

.task-calendar-day-detail:hover {
  cursor: pointer;
}

.cv-weekdays {
  overflow-y: hidden;
}

/* Hide library's absolutely-positioned items; we render them in the dayContent slot instead */
.calendar-content .cv-item {
  display: none !important;
}

/* Make each day cell a flex column so the scroll container fills remaining space */
.calendar-content .cv-day {
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.day-scroll-container {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 2px 2px;
}

.day-task-item {
  border: 0.5px solid var(--rentalios-dark);
  border-radius: 4px;
  font-size: 10px;
  color: var(--rentalios-dark);
  padding: 4px 22px 4px 5px;
  text-align: left;
  cursor: pointer;
  background: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 0;
  position: relative;
}

.day-task-item::after {
  position: absolute;
  content: '...';
  transform: translateY(-50%) rotate(90deg);
  font-size: 16px;
  display: inline-block;
  right: 4px;
  top: 50%;
}

div.today {
  background: #f0f8e8;
}

/* Desktop Calendar - fluid, no-scroll layout */
@media (min-width: 769px) {
  /* Header wrapper */
  .calendar-content .header-wrapper {
    height: auto !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    width: 100% !important;
    position: relative !important;
    flex-shrink: 0 !important;
  }

  .header-wrapper .left {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
  }

  .header-wrapper .right {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    bottom: auto !important;
  }

  .header-wrapper .current-date {
    font-size: 24px !important;
    font-weight: 800 !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  .header-wrapper .arrow-btn {
    width: 36px !important;
    height: 36px !important;
    padding: 6px !important;
  }

  .header-wrapper .right .select-btn {
    width: 140px !important;
    height: 40px !important;
    font-size: 14px !important;
    padding-left: 12px !important;
    margin-left: 0 !important;
  }

  .header-wrapper .right .new-chore {
    width: 160px !important;
    height: 40px !important;
    font-size: 14px !important;
    margin-left: 0 !important;
  }

  /* Task items */
  .calendar-content .cv-item.task-date {
    width: calc(100% / 7 - 8px) !important;
    box-sizing: border-box !important;
    margin: 8px 4px 4px 4px !important;
    font-size: 11px !important;
    padding: 6px 8px !important;
    line-height: 1.3 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

  .calendar-content .cv-item.task-date::after {
    font-size: 14px !important;
    right: 4px !important;
  }

  .task-calendar-day-detail-container {
    height: 24px !important;
    margin-top: 4px !important;
  }

  .task-calendar-day-detail {
    width: 24px !important;
    height: 24px !important;
    font-size: 10px !important;
    line-height: 24px !important;
  }
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .calendar-body {
    padding: 0 !important;
    margin: 0 !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  /* Ensure proper mobile layout */
  .calendar-body .calendar-wrapper {
    width: 100% !important;
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .calendar-body .calendar-wrapper .calendar-content {
    margin: 0 !important;
    padding: 16px 8px 20px 8px !important;
    min-width: 800px !important;
    width: max-content !important;
    box-sizing: border-box !important;
  }

  /* Vue Simple Calendar Overrides - More Specific */
  .calendar-content >>> .cv-wrapper {
    min-width: 800px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header {
    min-width: 800px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays {
    min-width: 800px !important;
    width: max-content !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays .cv-weekday {
    min-width: calc(800px / 7) !important;
    width: calc(800px / 7) !important;
    flex: 0 0 calc(800px / 7) !important;
    font-size: 12px !important;
    padding: 8px 4px !important;
    text-align: center !important;
  }

  .calendar-content >>> .cv-weeks {
    min-width: 800px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-weeks .cv-week {
    min-width: 800px !important;
    width: max-content !important;
    min-height: 100px !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-weeks .cv-week .cv-day {
    min-width: calc(800px / 7) !important;
    width: calc(800px / 7) !important;
    flex: 0 0 calc(800px / 7) !important;
    height: 100px !important;
    padding: 4px !important;
    font-size: 12px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .calendar-content .header-wrapper {
    height: auto !important;
    margin-top: 16px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
    width: 100% !important;
    position: relative !important;
  }

  .header-wrapper .left {
    position: relative !important;
    width: 100% !important;
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    gap: 8px !important;
  }

  .header-wrapper .right {
    position: relative !important;
    width: 100% !important;
    display: flex !important;
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
    gap: 8px !important;
    bottom: auto !important;
  }

  .header-wrapper .right .select-btn {
    width: calc(50% - 4px) !important;
    min-width: 120px !important;
    margin-left: 0 !important;
    font-size: 11px !important;
    padding-left: 8px !important;
    height: 36px !important;
    flex-shrink: 0 !important;
  }

  .header-wrapper .right .new-chore {
    width: 140px !important;
    min-width: 140px !important;
    margin-left: 0 !important;
    font-size: 11px !important;
    height: 36px !important;
    flex-shrink: 0 !important;
  }

  .calendar-content .header-wrapper {
    margin-bottom: 20px !important;
  }

  .header-wrapper .current-date {
    font-size: 16px !important;
    padding-left: 0 !important;
    text-align: left !important;
    margin: 0 !important;
  }

  .header-wrapper .arrow-btn {
    width: 28px !important;
    height: 28px !important;
    padding: 4px !important;
  }

  .calendar-content .cv-item.task-date {
    font-size: 8px !important;
    padding: 2px 4px !important;
    margin: 2px 0px 1px 2px !important;
    line-height: 1.2 !important;
    word-wrap: break-word !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    box-sizing: border-box !important;
  }

  .calendar-content .cv-item.task-date::after {
    font-size: 12px !important;
    right: 2px !important;
  }

  .task-calendar-day-detail-container {
    height: 14px !important;
    width: 100% !important;
    display: flex !important;
    justify-content: flex-end !important;
  }

  .task-calendar-day-detail {
    width: 14px !important;
    height: 14px !important;
    font-size: 7px !important;
    line-height: 14px !important;
  }
}

@media (max-width: 480px) {
  .calendar-body {
    padding: 0 !important;
    margin: 0 !important;
  }

  .calendar-body .calendar-wrapper .calendar-content {
    min-width: 700px !important;
    padding: 12px 4px 16px 4px !important;
  }

  .calendar-content >>> .cv-wrapper {
    min-width: 700px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header {
    min-width: 700px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays {
    min-width: 700px !important;
    width: max-content !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays .cv-weekday {
    min-width: calc(700px / 7) !important;
    width: calc(700px / 7) !important;
    flex: 0 0 calc(700px / 7) !important;
    font-size: 10px !important;
    padding: 6px 2px !important;
    text-align: center !important;
  }

  .calendar-content >>> .cv-weeks {
    min-width: 700px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-weeks .cv-week {
    min-width: 700px !important;
    width: max-content !important;
    min-height: 80px !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-weeks .cv-week .cv-day {
    min-width: calc(700px / 7) !important;
    width: calc(700px / 7) !important;
    flex: 0 0 calc(700px / 7) !important;
    height: 80px !important;
    padding: 2px !important;
    font-size: 10px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .calendar-content .header-wrapper {
    margin-top: 12px !important;
    gap: 8px !important;
  }

  .header-wrapper .left {
    justify-content: flex-start !important;
  }

  .header-wrapper .right {
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
  }

  .header-wrapper .right .select-btn {
    width: calc(50% - 2px) !important;
    min-width: 100px !important;
    font-size: 10px !important;
    height: 32px !important;
    padding-left: 6px !important;
    flex-shrink: 0 !important;
  }

  .header-wrapper .right .new-chore {
    width: 120px !important;
    min-width: 120px !important;
    font-size: 10px !important;
    height: 32px !important;
    flex-shrink: 0 !important;
  }

  .calendar-content .header-wrapper {
    margin-bottom: 16px !important;
  }

  .header-wrapper .current-date {
    font-size: 14px !important;
    text-align: left !important;
  }

  .header-wrapper .arrow-btn {
    width: 24px !important;
    height: 24px !important;
    padding: 2px !important;
  }

  .calendar-content .cv-item.task-date {
    width: calc(100% - 6px) !important;
    max-width: calc(calc(700px / 7) - 6px) !important;
    font-size: 7px !important;
    padding: 1px 2px !important;
    margin: 1px 0px 1px 1px !important;
    box-sizing: border-box !important;
  }

  .calendar-content .cv-item.task-date::after {
    font-size: 10px !important;
    right: 1px !important;
  }

  .task-calendar-day-detail-container {
    height: 12px !important;
  }

  .task-calendar-day-detail {
    width: 12px !important;
    height: 12px !important;
    font-size: 6px !important;
    line-height: 12px !important;
  }
}

@media (max-width: 360px) {
  .calendar-body .calendar-wrapper .calendar-content {
    min-width: 600px !important;
    padding: 8px 2px 12px 2px !important;
  }

  .calendar-content >>> .cv-wrapper {
    min-width: 600px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header {
    min-width: 600px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays {
    min-width: 600px !important;
    width: max-content !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-header .cv-weekdays .cv-weekday {
    min-width: calc(600px / 7) !important;
    width: calc(600px / 7) !important;
    flex: 0 0 calc(600px / 7) !important;
    font-size: 9px !important;
    padding: 4px 1px !important;
    text-align: center !important;
  }

  .calendar-content >>> .cv-weeks {
    min-width: 600px !important;
    width: max-content !important;
    overflow-x: auto !important;
  }

  .calendar-content >>> .cv-weeks .cv-week {
    min-width: 600px !important;
    width: max-content !important;
    min-height: 70px !important;
    display: flex !important;
    flex-direction: row !important;
  }

  .calendar-content >>> .cv-weeks .cv-week .cv-day {
    min-width: calc(600px / 7) !important;
    width: calc(600px / 7) !important;
    flex: 0 0 calc(600px / 7) !important;
    height: 70px !important;
    padding: 1px !important;
    font-size: 9px !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
  }

  .header-wrapper .left {
    justify-content: flex-start !important;
  }

  .header-wrapper .right {
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
  }

  .header-wrapper .right .select-btn {
    width: calc(50% - 2px) !important;
    margin-bottom: 0 !important;
    min-width: 80px !important;
    flex-shrink: 0 !important;
  }

  .header-wrapper .right .new-chore {
    width: 100px !important;
    min-width: 100px !important;
    flex-shrink: 0 !important;
  }

  .calendar-content .header-wrapper {
    margin-bottom: 12px !important;
  }

  .calendar-content .cv-item.task-date {
    width: calc(100% - 4px) !important;
    max-width: calc(calc(600px / 7) - 4px) !important;
    font-size: 6px !important;
    padding: 1px !important;
    margin: 1px 0px 0px 1px !important;
    box-sizing: border-box !important;
  }

  .calendar-content .cv-item.task-date::after {
    font-size: 8px !important;
    right: 0px !important;
  }

  .task-calendar-day-detail-container {
    height: 10px !important;
  }

  .task-calendar-day-detail {
    width: 10px !important;
    height: 10px !important;
    font-size: 5px !important;
    line-height: 10px !important;
  }
}
</style>
